/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Account_SuspendInputs */



/**
* | output |
* | --- |
* | "Suspended an account" |
*
* @param {Activity_Account_SuspendInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const activity_account_suspend = /** @type {((inputs?: Activity_Account_SuspendInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Account_SuspendInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Аккаунт приостановлен")
	return /** @type {LocalizedString} */ ("Suspended an account")
});